<div fxLayout="column" [formGroup]="formGroup">
  <div class="content" fxLayout="row" fxLayout.xs="column" fxLayoutGap="20px" fxLayoutGap.xs="0">
    <div fxLayout="column" fxFlex="1 1 auto">
      <dff-form-control [formControl]="formGroup.get('tekst.aktuel')"></dff-form-control>
      <dff-form-control [formControl]="formGroup.get('serieNr.aktuel')"></dff-form-control>
      <dff-form-control [formControl]="formGroup.get('opsatDato.aktuel')"></dff-form-control>
      <dff-form-control [formControl]="formGroup.get('senestServiceDato.aktuel')"></dff-form-control>
      <dff-form-control [formControl]="formGroup.get('serviceDato.aktuel')"></dff-form-control>
      <dff-form-control [formControl]="formGroup.get('serviceIntervalAar.aktuel')"></dff-form-control>
    </div>

    <!-- Dimensioner -->
    @if (dimensioner.controls.length) {
      <div fxLayout="column" fxFlex="1 1 auto">
        @for (dimension of dimensioner.controls; track dimension) {
          <dff-form-control
            [formControl]="dimension.get('vaerdi.aktuel')">
          </dff-form-control>
        }
      </div>
    }

  </div>

  <section class="noter" fxLayout="column" fxFlex="1 1 auto">
    <div>
      <h3 mat-subheader>Noter på denne komponent</h3>
      <komponent-note-liste [formArray]="formGroup.get('noter')"></komponent-note-liste>
    </div>
  </section>
</div>